const Customizations = {

  updatePrice: function () {
    const inputs = document.querySelectorAll('.prod-customization input[type="radio"][data-customization-price]');
    inputs.forEach(input => {
      input.addEventListener('change', function () {
        const priceDisplay = this.closest('.prod-customization').querySelector('.option-title .value');
        const price = parseFloat(this.getAttribute('data-customization-price'));
        priceDisplay.textContent = price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      });
    });
  },

  pattern: function () {
    const inputs = document.querySelectorAll('.prod-customization input[data-pattern]');

    inputs.forEach(input => {
      input.addEventListener('keydown', (event) => {
        const pattern = input.getAttribute('data-pattern');
        const regex = new RegExp(pattern);
        const currentValue = input.value;
        const currentKey = event.key;
        const newValue = currentValue + currentKey;

        if (!regex.test(newValue)) {
          event.preventDefault();
        }
      });
    });
  },

  init: function () {
    this.pattern();
    this.updatePrice();
  }
}

export default Customizations;